import { render, staticRenderFns } from "./paging.vue?vue&type=template&id=5e43c71a&scoped=true&"
import script from "./paging.vue?vue&type=script&lang=js&"
export * from "./paging.vue?vue&type=script&lang=js&"
import style0 from "./paging.vue?vue&type=style&index=0&id=5e43c71a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e43c71a",
  null
  
)

export default component.exports